"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiStorefrontCardImpression = void 0;
/**
 * A builder for HifiStorefrontCardImpression
 *
 * @param data - The event data
 * @return The formatted event data for HifiStorefrontCardImpressionEvent
 */
function createHifiStorefrontCardImpression(data) {
    return {
        name: 'HifiStorefrontCardImpression',
        environments: ['browser'],
        data: data,
    };
}
exports.createHifiStorefrontCardImpression = createHifiStorefrontCardImpression;
//# sourceMappingURL=createHifiStorefrontCardImpression.js.map